<template>
  <section hidden="true">
    <h2>Community Involvement</h2>
    <p>Mention any involvement in tech communities, meetups, or open-source contributions.</p>
    <p>Highlight any speaking engagements or presentations.</p>
  </section>
</template>

<script>
export default {
  name: 'CommunityInvolvementSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>